import { render, staticRenderFns } from "./OverflowTooltip.vue?vue&type=template&id=7d74213a&scoped=true&"
import script from "./OverflowTooltip.vue?vue&type=script&lang=ts&"
export * from "./OverflowTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./OverflowTooltip.vue?vue&type=style&index=0&id=7d74213a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d74213a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VTooltip})
